import React, { useState, useEffect, ChangeEvent } from 'react';
import { Input } from 'components/input';

/**
 * These Props are injected by React-table function.
 * There are more props we can look(investigate props object), but these are required for now.
 * Please look into RMTable for understanding or ask around.
 */
interface Props {
  currentEditingRowId: number;
  row: any;
  rows: any;
  cell: any;
  rowEditingContent: any;
  setRowEditingContent: React.Dispatch<React.SetStateAction<{}>>;
}

const EditableCell = (props: Props) => {
  const { cell, row, currentEditingRowId, setRowEditingContent } = props;

  const [state, setState] = useState<string | number>(cell.value);

  const handleOnChange = (e: ChangeEvent<HTMLInputElement>) => {
    setState(e.target.value);
  };

  const handleOnBlur = () => {
    if (setRowEditingContent) {
      setRowEditingContent((prvState) => ({
        ...prvState,
        [cell.column.id]: state,
      }));
    }
  };

  useEffect(() => {
    setState(cell.value);
  }, [cell.value]);

  if (
    !cell.column.editOptions ||
    cell.column.editoptions?.hasCustomComponent ||
    currentEditingRowId !== row.index
  ) {
    return cell.value;
  }

  return (
    <Input
      id="table-editablecell-input"
      className="w-full focus:outline-none border-[#006AF5] rounded-sm bg-transparent text-start h-8 rm-input-number"
      value={state}
      onChange={handleOnChange}
      onBlur={handleOnBlur}
      {...cell.column?.editOptions}
    />
  );
};

export default EditableCell;
